/**
 * Generated by orval v7.5.0 🍺
 * Do not edit manually.
 * Template API
 * Something something. <br><br>The spec is available at <a href='/swagger/api.json'>/swagger/api.json</a>.
 * OpenAPI spec version: 0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query'
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'
import type {
  ApiAppError,
  CreateCategoryRequest,
  CreateCategoryResponse,
  GetCategoriesOptionallyfilteredbylocationParams,
  GetCategoriesResponse,
  GetCategoryResponse,
  UpdateCategoryRequest,
  UpdateCategoryResponse
} from './schemas'
import { getApi } from '../client';
import type { ErrorType, BodyType } from '../client';



type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];


/**
 * @summary Get Categories (optionally filtered by location)
 */
export const getCategoriesOptionallyfilteredbylocation = (
    params?: GetCategoriesOptionallyfilteredbylocationParams,
 options?: SecondParameter<typeof getApi>,signal?: AbortSignal
) => {
      
      
      return getApi<GetCategoriesResponse>(
      {url: `/categories`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetCategoriesOptionallyfilteredbylocationQueryKey = (params?: GetCategoriesOptionallyfilteredbylocationParams,) => {
    return [`/categories`, ...(params ? [params]: [])] as const;
    }

    
export const getGetCategoriesOptionallyfilteredbylocationQueryOptions = <TData = Awaited<ReturnType<typeof getCategoriesOptionallyfilteredbylocation>>, TError = ErrorType<ApiAppError>>(params?: GetCategoriesOptionallyfilteredbylocationParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCategoriesOptionallyfilteredbylocation>>, TError, TData>>, request?: SecondParameter<typeof getApi>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCategoriesOptionallyfilteredbylocationQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCategoriesOptionallyfilteredbylocation>>> = ({ signal }) => getCategoriesOptionallyfilteredbylocation(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCategoriesOptionallyfilteredbylocation>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCategoriesOptionallyfilteredbylocationQueryResult = NonNullable<Awaited<ReturnType<typeof getCategoriesOptionallyfilteredbylocation>>>
export type GetCategoriesOptionallyfilteredbylocationQueryError = ErrorType<ApiAppError>


export function useGetCategoriesOptionallyfilteredbylocation<TData = Awaited<ReturnType<typeof getCategoriesOptionallyfilteredbylocation>>, TError = ErrorType<ApiAppError>>(
 params: undefined |  GetCategoriesOptionallyfilteredbylocationParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCategoriesOptionallyfilteredbylocation>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCategoriesOptionallyfilteredbylocation>>,
          TError,
          Awaited<ReturnType<typeof getCategoriesOptionallyfilteredbylocation>>
        > , 'initialData'
      >, request?: SecondParameter<typeof getApi>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCategoriesOptionallyfilteredbylocation<TData = Awaited<ReturnType<typeof getCategoriesOptionallyfilteredbylocation>>, TError = ErrorType<ApiAppError>>(
 params?: GetCategoriesOptionallyfilteredbylocationParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCategoriesOptionallyfilteredbylocation>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCategoriesOptionallyfilteredbylocation>>,
          TError,
          Awaited<ReturnType<typeof getCategoriesOptionallyfilteredbylocation>>
        > , 'initialData'
      >, request?: SecondParameter<typeof getApi>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCategoriesOptionallyfilteredbylocation<TData = Awaited<ReturnType<typeof getCategoriesOptionallyfilteredbylocation>>, TError = ErrorType<ApiAppError>>(
 params?: GetCategoriesOptionallyfilteredbylocationParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCategoriesOptionallyfilteredbylocation>>, TError, TData>>, request?: SecondParameter<typeof getApi>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Categories (optionally filtered by location)
 */

export function useGetCategoriesOptionallyfilteredbylocation<TData = Awaited<ReturnType<typeof getCategoriesOptionallyfilteredbylocation>>, TError = ErrorType<ApiAppError>>(
 params?: GetCategoriesOptionallyfilteredbylocationParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCategoriesOptionallyfilteredbylocation>>, TError, TData>>, request?: SecondParameter<typeof getApi>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCategoriesOptionallyfilteredbylocationQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary Get Categories (optionally filtered by location)
 */
export const prefetchGetCategoriesOptionallyfilteredbylocation = async <TData = Awaited<ReturnType<typeof getCategoriesOptionallyfilteredbylocation>>, TError = ErrorType<ApiAppError>>(
 queryClient: QueryClient, params?: GetCategoriesOptionallyfilteredbylocationParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCategoriesOptionallyfilteredbylocation>>, TError, TData>>, request?: SecondParameter<typeof getApi>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetCategoriesOptionallyfilteredbylocationQueryOptions(params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}


/**
 * @summary Create Category
 */
export const createCategory = (
    createCategoryRequest: BodyType<CreateCategoryRequest>,
 options?: SecondParameter<typeof getApi>,signal?: AbortSignal
) => {
      
      
      return getApi<CreateCategoryResponse>(
      {url: `/category`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createCategoryRequest, signal
    },
      options);
    }
  


export const getCreateCategoryMutationOptions = <TError = ErrorType<ApiAppError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCategory>>, TError,{data: BodyType<CreateCategoryRequest>}, TContext>, request?: SecondParameter<typeof getApi>}
): UseMutationOptions<Awaited<ReturnType<typeof createCategory>>, TError,{data: BodyType<CreateCategoryRequest>}, TContext> => {
    
const mutationKey = ['createCategory'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createCategory>>, {data: BodyType<CreateCategoryRequest>}> = (props) => {
          const {data} = props ?? {};

          return  createCategory(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateCategoryMutationResult = NonNullable<Awaited<ReturnType<typeof createCategory>>>
    export type CreateCategoryMutationBody = BodyType<CreateCategoryRequest>
    export type CreateCategoryMutationError = ErrorType<ApiAppError>

    /**
 * @summary Create Category
 */
export const useCreateCategory = <TError = ErrorType<ApiAppError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCategory>>, TError,{data: BodyType<CreateCategoryRequest>}, TContext>, request?: SecondParameter<typeof getApi>}
): UseMutationResult<
        Awaited<ReturnType<typeof createCategory>>,
        TError,
        {data: BodyType<CreateCategoryRequest>},
        TContext
      > => {

      const mutationOptions = getCreateCategoryMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Delete Category
 */
export const deleteCategory = (
    id: string,
 options?: SecondParameter<typeof getApi>,) => {
      
      
      return getApi<void>(
      {url: `/category/${id}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteCategoryMutationOptions = <TError = ErrorType<ApiAppError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCategory>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof getApi>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteCategory>>, TError,{id: string}, TContext> => {
    
const mutationKey = ['deleteCategory'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteCategory>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteCategory(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteCategoryMutationResult = NonNullable<Awaited<ReturnType<typeof deleteCategory>>>
    
    export type DeleteCategoryMutationError = ErrorType<ApiAppError>

    /**
 * @summary Delete Category
 */
export const useDeleteCategory = <TError = ErrorType<ApiAppError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCategory>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof getApi>}
): UseMutationResult<
        Awaited<ReturnType<typeof deleteCategory>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteCategoryMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Get Category
 */
export const getCategory = (
    id: string,
 options?: SecondParameter<typeof getApi>,signal?: AbortSignal
) => {
      
      
      return getApi<GetCategoryResponse>(
      {url: `/category/${id}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetCategoryQueryKey = (id: string,) => {
    return [`/category/${id}`] as const;
    }

    
export const getGetCategoryQueryOptions = <TData = Awaited<ReturnType<typeof getCategory>>, TError = ErrorType<ApiAppError>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCategory>>, TError, TData>>, request?: SecondParameter<typeof getApi>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCategoryQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCategory>>> = ({ signal }) => getCategory(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCategory>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCategoryQueryResult = NonNullable<Awaited<ReturnType<typeof getCategory>>>
export type GetCategoryQueryError = ErrorType<ApiAppError>


export function useGetCategory<TData = Awaited<ReturnType<typeof getCategory>>, TError = ErrorType<ApiAppError>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCategory>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCategory>>,
          TError,
          Awaited<ReturnType<typeof getCategory>>
        > , 'initialData'
      >, request?: SecondParameter<typeof getApi>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCategory<TData = Awaited<ReturnType<typeof getCategory>>, TError = ErrorType<ApiAppError>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCategory>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCategory>>,
          TError,
          Awaited<ReturnType<typeof getCategory>>
        > , 'initialData'
      >, request?: SecondParameter<typeof getApi>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCategory<TData = Awaited<ReturnType<typeof getCategory>>, TError = ErrorType<ApiAppError>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCategory>>, TError, TData>>, request?: SecondParameter<typeof getApi>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Category
 */

export function useGetCategory<TData = Awaited<ReturnType<typeof getCategory>>, TError = ErrorType<ApiAppError>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCategory>>, TError, TData>>, request?: SecondParameter<typeof getApi>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCategoryQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary Get Category
 */
export const prefetchGetCategory = async <TData = Awaited<ReturnType<typeof getCategory>>, TError = ErrorType<ApiAppError>>(
 queryClient: QueryClient, id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCategory>>, TError, TData>>, request?: SecondParameter<typeof getApi>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetCategoryQueryOptions(id,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}


/**
 * @summary Update Category
 */
export const updateCategory = (
    id: string,
    updateCategoryRequest: BodyType<UpdateCategoryRequest>,
 options?: SecondParameter<typeof getApi>,) => {
      
      
      return getApi<UpdateCategoryResponse>(
      {url: `/category/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateCategoryRequest
    },
      options);
    }
  


export const getUpdateCategoryMutationOptions = <TError = ErrorType<ApiAppError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCategory>>, TError,{id: string;data: BodyType<UpdateCategoryRequest>}, TContext>, request?: SecondParameter<typeof getApi>}
): UseMutationOptions<Awaited<ReturnType<typeof updateCategory>>, TError,{id: string;data: BodyType<UpdateCategoryRequest>}, TContext> => {
    
const mutationKey = ['updateCategory'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateCategory>>, {id: string;data: BodyType<UpdateCategoryRequest>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateCategory(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateCategoryMutationResult = NonNullable<Awaited<ReturnType<typeof updateCategory>>>
    export type UpdateCategoryMutationBody = BodyType<UpdateCategoryRequest>
    export type UpdateCategoryMutationError = ErrorType<ApiAppError>

    /**
 * @summary Update Category
 */
export const useUpdateCategory = <TError = ErrorType<ApiAppError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCategory>>, TError,{id: string;data: BodyType<UpdateCategoryRequest>}, TContext>, request?: SecondParameter<typeof getApi>}
): UseMutationResult<
        Awaited<ReturnType<typeof updateCategory>>,
        TError,
        {id: string;data: BodyType<UpdateCategoryRequest>},
        TContext
      > => {

      const mutationOptions = getUpdateCategoryMutationOptions(options);

      return useMutation(mutationOptions);
    }
    